import safeCreateAction from "../../../actions/safeCreateAction";
export const addMod = safeCreateAction("ADD_MOD", (gameId, mod) => ({ gameId, mod }));
export const addMods = safeCreateAction("ADD_MODS", (gameId, mods) => ({ gameId, mods }));
export const removeMod = safeCreateAction("REMOVE_MOD", (gameId, modId) => ({ gameId, modId }));
export const setModArchiveId = safeCreateAction("SET_MOD_ARCHIVEID", (gameId, modId, archiveId) => ({
    gameId,
    modId,
    archiveId,
}));
/**
 * sets the state of a mod (whether it's downloaded, installed, ...)
 */
export const setModState = safeCreateAction("SET_MOD_STATE", (gameId, modId, modState) => ({
    gameId,
    modId,
    modState,
}));
/**
 * sets the (final) installation path of the mod. This should be set as soon as
 * any data is written to disk so that it can be cleaned/removed in case of an error.
 * The actual path on disk may be a variation of this path during installation.
 */
export const setModInstallationPath = safeCreateAction("SET_MOD_INSTALLATION_PATH", (gameId, modId, installPath) => ({
    gameId,
    modId,
    installPath,
}));
/**
 * sets the value of an attribute on a mod
 */
export const setModAttribute = safeCreateAction("SET_MOD_ATTRIBUTE", (gameId, modId, attribute, value) => ({
    gameId,
    modId,
    attribute,
    value,
}));
/**
 * set multiple mod attributes at once
 */
export const setModAttributes = safeCreateAction("SET_MOD_ATTRIBUTES", (gameId, modId, attributes) => ({ gameId, modId, attributes }));
/**
 * sets the type of a mod
 */
export const setModType = safeCreateAction("SET_MOD_TYPE", (gameId, modId, type) => ({ gameId, modId, type }));
export const clearModRules = safeCreateAction("CLEAR_MOD_RULE", (gameId, modId) => ({ gameId, modId }));
/**
 * add a dependency rule for this mod
 */
export const addModRule = safeCreateAction("ADD_MOD_RULE", (gameId, modId, rule) => ({ gameId, modId, rule }));
/**
 * remove a dependency rule from this mod
 */
export const removeModRule = safeCreateAction("REMOVE_MOD_RULE", (gameId, modId, rule) => ({ gameId, modId, rule }));
/**
 * store the mod id for a resolved rule, so we can resolve it quicker and more
 * reliably in the future
 */
export const cacheModReference = safeCreateAction("CACHE_MOD_REFERENCE", (gameId, modId, reference, refModId) => ({ gameId, modId, reference, refModId }));
export const setINITweakEnabled = safeCreateAction("SET_TWEAK_ENABLED", (gameId, modId, tweak, enabled) => ({
    gameId,
    modId,
    tweak,
    enabled,
}));
/**
 * set list of files that will always be provided by this mod, no matter the deployment order
 */
export const setFileOverride = safeCreateAction("SET_FILE_OVERRIDE", (gameId, modId, files) => ({
    gameId,
    modId,
    files,
}));
